import {
  getUserInfo,
  getUserMenus,
  getUserOptions,
  getUserResources,
  login,
  logout,
  registerUser,
  supperLogin,
  queryTenant,
} from '@/api/user'
import {
  getAccount,
  getTenant,
  getToken, getUserId,
  removeAccount,
  removeTenant,
  removeToken, removeUserId,removePE,
  setAccount, setRegisterInfo,
  setTenant,
  setToken, setUserId
} from '@/utils/auth'
import {
  userCompanyInfo
} from '@/api/personal-center'
import router, {resetRouter} from '@/router'
import {
  GET_ACTIVE_USER_OPTIONS, GET_AUTH_COUNTRIES, GET_AUTH_MARKETS,
  GET_COUNTRIES,
  GET_INFO,
  GET_INFO_SUCCESS,
  GET_MARKETS,
  GET_ADMARKETS,
  GET_USER_OPTIONS,
  LOGIN,
  LOGOUT,
  PRODUCT_GET_PRODUCT_BRAND,
  PRODUCT_GET_PRODUCT_CATEGORY_TREE,
  REGISTER,
  RESET_USER, WAREHOUSE_GET_ACTIVE_FBA_WAREHOUSE_TREE,
  WAREHOUSE_GET_FBA_WAREHOUSE_TREE,
  GET_TENANT_PAY,
  INNER_GET_COMPANY_INFO,
  GET_POLLING, GET_MARKET_AUTH_TYPE,REFRESH_MARKET_AUTH_TYPE
} from "@/store/action-types";
import {
  SET_ACCOUNT, SET_ACTIVE_USER_OPTIONS,
  SET_CHECKED_USER_STATE, SET_KEEP_ALIVE_VIEWS,
  SET_TENANT,
  SET_TOKEN,
  SET_USER_INFO,
  SET_USER_MENUS,
  SET_USER_OPTIONS,
  SET_TENANT_PAY,
  SET_USER_RESOURCES, SET_FIRST_LOGIN, SET_USER_ID, SET_COMPANY_INFO,
  PURCHASE_SET_SUPPLIER, PURCHASE_SET_ACTIVE_SUPPLIER,
  LOGISTICS_SET_LOGISTICS_OPTIONS, LOGISTICS_SET_ACTIVE_LOGISTICS_OPTIONS,
  SET_MESSAGE, SET_POLLING, SET_KNOW, SET_STATUS, SET_ISMSGSGLOBAL,
  SET_TOKEN_COOKIES, SET_TENANT_COOKIES, SET_ACCOUNT_COOKIES, SET_USER_ID_COOKIES,
  SET_MARKET_AUTH_TYPE, SET_LATEST_VERSION_ID,
  DASHBOARD_SET_TIMEZONE_ID,
  DASHBOARD_SET_TIMEZONE_TEXT,
  DASHBOARD_SET_CURRENCY
} from "@/store/mutation-types";
import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
import {RESPONSE_CODE} from "@/utils/const";
import _ from 'lodash';
import {getPollingStatus} from "@/api/warning";
import md5 from "js-md5";
import {marketAuthType} from "@/api/dashboard";

const LOGIN_SUCCESS = 'login_success';
const GET_USER_MENU = 'GET_USER_MENU';
const GET_USER_RESOURCES = 'GET_USER_RESOURCES';
const SET_USER_LOAD_RESOURCES = 'SET_USER_LOAD_RESOURCES';

const state = {
  firstLogin: false,
  token: getToken(),
  tenant: getTenant(),
  userId: getUserId(),
  account: null,
  checkedUserState: false,
  userInfo: {
    roleName: ''
  },
  userOptions: [],
  activeUserOptions: [],
  userMenus: [],
  useLoadResources: false,
  userResources: [],
  companyInfo: [],
  tenantPay:{},
  msgNumber:{
      // 系统消息
      system:0,
      // 账户消息
      account:0,
      // 运营消息
      operation:0
  },
  isPolling: false,
  refreshMessage: null,
  marketAuthType: [],
  latestVersionId: null,
  isMsgsGlobal: false, // 是否有全局消息提示
};

const mutations = {
  [SET_LATEST_VERSION_ID](state, latestVersionId){
    state.latestVersionId = latestVersionId
  },
  [SET_MARKET_AUTH_TYPE](state, marketAuthType) {
    state.marketAuthType = marketAuthType
  },
  [SET_COMPANY_INFO](state, info) {
    state.companyInfo = info
  },
  [SET_FIRST_LOGIN](state, firstLogin) {
    state.firstLogin = firstLogin;
  },
  [SET_TOKEN](state, token) {
    state.token = token;
  },
  [SET_TENANT](state, tenant) {
    state.tenant = tenant;
  },
  [SET_USER_ID](state, userId) {
    state.userId = userId;
  },
  [SET_ACCOUNT](state, account) {
    state.account = account;
  },

  [SET_TOKEN_COOKIES](state, {token, sevenDaysNoPassword}) {
    setToken(token, sevenDaysNoPassword);
  },
  [SET_TENANT_COOKIES](state, {tenant, sevenDaysNoPassword}) {
    setTenant(tenant, sevenDaysNoPassword);
  },
  [SET_USER_ID_COOKIES](state, {userId, sevenDaysNoPassword}) {
    setUserId(userId, sevenDaysNoPassword);
  },
  [SET_ACCOUNT_COOKIES](state, {account, sevenDaysNoPassword}) {
    setAccount(account, sevenDaysNoPassword);
  },

  [SET_CHECKED_USER_STATE](state, checkedUserState) {
    state.checkedUserState = checkedUserState;
  },
  [SET_USER_INFO](state, data) {
    state.userInfo = data
  },
  [SET_USER_OPTIONS](state, data) {
    state.userOptions = data;
  },
  [SET_ACTIVE_USER_OPTIONS](state, data) {
    state.activeUserOptions = data;
  },
  [SET_USER_MENUS](state, data) {
    state.userMenus = data;
  },
  [SET_USER_RESOURCES](state, data) {
    state.userResources = data;
  },
  [SET_USER_LOAD_RESOURCES](state, data) {
    state.useLoadResources = data;
  },
  [SET_TENANT_PAY](state, data) {
    state.tenantPay = data;
  },
  [SET_MESSAGE](state, data) {
    state.msgNumber[data.type] = data.value;
  },
//  设置是否开启轮询
  [SET_POLLING](state, data){
    state.isPolling = data;
  },
  [SET_KNOW](state){
    state.refreshMessage = Date.now();
  },
  // 设置是否有全局消息提醒
  [SET_ISMSGSGLOBAL](state, data) {
    state.isMsgsGlobal = data;
  }
};

const actions = {
  // user login
  [LOGIN]({ commit, dispatch }, userInfo) {
    const { username, password , grantType, sevenDaysNoPassword, isSupperLogin, code, loginType } = userInfo;
    return new Promise((resolve, reject) => {
      const params = {
        account: username.trim(),
        password: password,
        grantType: grantType,
        day7: sevenDaysNoPassword,
        loginType,
        code
      };
      Promise.resolve(isSupperLogin)
        .then((isSupperLogin) => {
          if (isMeaningful(isSupperLogin) && _.isBoolean(isSupperLogin) && isSupperLogin) {
            return supperLogin(params);
          } else {
            return login(params);
          }
        })
        .then(res => {
          if (res.code === RESPONSE_CODE.SUCCESS) {
            const {account, name, tenant} = res.data;
            // eslint-disable-next-line no-undef
            sensorsdata.login(md5(tenant + 'M' + res.data.userId));
            window.sensorsdataTenant = tenant;
            window.gjUserInfo = res.data;
            // eslint-disable-next-line no-undef
            sensorsdata.setProfile({app: 'M', account, name, companyName: tenant});
            // eslint-disable-next-line no-undef
            sensorsdata.track('login', {
              state: '登录成功',
            })
            resolve(res.data);
            dispatch(LOGIN_SUCCESS, {data:res.data, sevenDaysNoPassword});
          } else {
            // eslint-disable-next-line no-undef
            sensorsdata.track('login', {
              state: '登录失败',
            })
            reject(res);
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-undef
          sensorsdata.track('login', {
            state: '登录失败',
            message: error.message
          })
          reject(error);
        })
    })
  },

  // user register
  [REGISTER]({ commit, dispatch }, userInfo) {
    const { phoneNumber, password, code, telephoneCode, name, tenantName  } = userInfo;
    return new Promise((resolve, reject) => {
      registerUser({
        phone: phoneNumber,
        code: code,
        password: password,
        salesCode: defaultVal(userInfo.salesCode, null),
        fromWebsite: defaultVal(userInfo.fromWebsite, null),
        internationalTelephoneCode: telephoneCode,
        tenantName: tenantName,
        name: name,
      }).then(res => {
        if (res.code === RESPONSE_CODE.SUCCESS) {
          resolve(res);
          setRegisterInfo({phone: phoneNumber});
          // router.replace('/login');
          // dispatch(LOGIN_SUCCESS, res.data);
        } else {
          reject(res);
        }
      }).catch(error => {
        reject(error);
      });
    });
  },

  async [LOGIN_SUCCESS]({ commit, dispatch }, { data, sevenDaysNoPassword } ) {
    commit(SET_TOKEN, data.token);
    commit(SET_TENANT, data.tenant);
    commit(SET_USER_ID, data.userId);
    commit(SET_ACCOUNT, data.account);
    commit(SET_TOKEN_COOKIES, {token: data.token, sevenDaysNoPassword});
    commit(SET_TENANT_COOKIES, {tenant: data.tenant, sevenDaysNoPassword});
    commit(SET_USER_ID_COOKIES, {userId: data.userId, sevenDaysNoPassword});
    commit(SET_ACCOUNT_COOKIES, {account: data.account, sevenDaysNoPassword});
    if (data.firstLogin) {
      commit(SET_FIRST_LOGIN, true);
    }
    //登录成功时会调用
    await dispatch(GET_MARKET_AUTH_TYPE);

    // 跳转到主页
    router.replace('/');
    dispatch(GET_INFO, false);
  },

  // get user info
  [GET_INFO]({ commit, state, dispatch }, immediateSuccess = false) {
    return new Promise((resolve, reject) => {
      const token = getToken();
      const tenant = getTenant();
      const account = getAccount();
      if (isMeaningless(tenant)
        || isMeaningless(account)
        || isMeaningless(token)) {
        dispatch(RESET_USER);
        commit(SET_CHECKED_USER_STATE, true);
        reject();
        return;
      }
      commit(SET_TOKEN, token);
      commit(SET_TENANT, tenant);
      if (!immediateSuccess) {
        getUserInfo(token).then((data) => {
          commit(SET_USER_INFO, data);
          commit(SET_ACCOUNT, account);
          dispatch(GET_INFO_SUCCESS);
          resolve(data)
        }).catch(error => {
          reject(error);
        }).complete(() => {
          commit(SET_CHECKED_USER_STATE, true);
        });
      } else {
        commit(SET_CHECKED_USER_STATE, true);
        dispatch(GET_INFO_SUCCESS);
        resolve();
      }
    });
  },

  async [GET_INFO_SUCCESS]({ commit, state, dispatch }, data) {
    //刷新页面时会调用
    await dispatch(GET_MARKET_AUTH_TYPE);
    // 获取用户可用菜单
    dispatch(GET_USER_MENU);
    // 获取用户可用资源
    dispatch(GET_USER_RESOURCES);
    if (state.firstLogin) {
      // 第一次登录无需加载下面的资源
      return;
    }
    // 获取国家、站点
    dispatch(GET_COUNTRIES, null, { root: true });
    dispatch(GET_MARKETS, null, { root: true });
    dispatch(GET_ADMARKETS, null, { root: true });
    dispatch(GET_AUTH_COUNTRIES, null, { root: true });
    dispatch(GET_AUTH_MARKETS, null, { root: true });
    // 获取用户下拉框
    dispatch(GET_USER_OPTIONS);
    // 获取启用用户下拉框
    dispatch(GET_ACTIVE_USER_OPTIONS);
    // 获取fba仓库树
    dispatch(WAREHOUSE_GET_FBA_WAREHOUSE_TREE, null, { root: true });
    // 获取启用fba仓库树
    dispatch(WAREHOUSE_GET_ACTIVE_FBA_WAREHOUSE_TREE, null, { root: true });
    // 获取产品品牌
    dispatch(PRODUCT_GET_PRODUCT_BRAND, null, { root: true });
    // 获取产品品类树
    dispatch(PRODUCT_GET_PRODUCT_CATEGORY_TREE, null, { root: true });
    //获取租户信息（是否付费）
    dispatch(GET_TENANT_PAY);

  },

  async [GET_MARKET_AUTH_TYPE]({ commit, state }) {
    if(state.marketAuthType.length === 0){
      await marketAuthType().then(data=>{
        commit(SET_MARKET_AUTH_TYPE,data)
      })
    }
  },
  async [REFRESH_MARKET_AUTH_TYPE]({ commit, state }) {
      await marketAuthType().then(data=>{
        commit(SET_MARKET_AUTH_TYPE,data)
      })
  },


  // 获取用户可用菜单
  [GET_USER_MENU]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getUserMenus().then(data => {
        commit(SET_USER_MENUS, data);
        resolve();
      }).catch(error => {
        reject(error);
      })
    });
  },

  // 获取用户可用菜单
  [GET_USER_RESOURCES]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getUserResources().then(data => {
        commit(SET_USER_LOAD_RESOURCES, true);
        commit(SET_USER_RESOURCES, data);
        resolve();
      }).catch(error => {
        reject(error);
      })
    });
  },

  // 获取用户下拉框
  [GET_USER_OPTIONS]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getUserOptions('ALL').then(data => {
        commit(SET_USER_OPTIONS, data);
        resolve();
      }).catch(error => {
        reject(error);
      })
    });
  },

  // 获取启用用户下拉框
  [GET_ACTIVE_USER_OPTIONS]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getUserOptions('ENABLE').then(data => {
        commit(SET_ACTIVE_USER_OPTIONS, data);
        resolve();
      }).catch(error => {
        reject(error);
      })
    });
  },

  //获取租户信息（是否付费）
  [GET_TENANT_PAY]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      queryTenant().then(data => {
        commit(SET_TENANT_PAY, data);
        resolve();
      }).catch(error => {
        reject(error);
      })
    });
  },


  // user logout
  [LOGOUT]({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        // 清空应用状态与缓存
        dispatch(RESET_USER);
        resetRouter();
        router.push('/login');
        resolve()
      }).catch(error => {
        reject(error)
      })

    });
  },

  // 重置用户信息
  [RESET_USER]({ commit }) {
    return new Promise(resolve => {
      commit(SET_TOKEN, null);
      commit(SET_TENANT, null);
      commit(SET_USER_ID, null);
      commit(SET_ACCOUNT, null);
      commit(SET_CHECKED_USER_STATE, false);
      commit(SET_USER_MENUS, []);
      commit(SET_USER_LOAD_RESOURCES, false);
      commit(SET_USER_RESOURCES, []);
      commit(SET_FIRST_LOGIN, false);
      commit(SET_KEEP_ALIVE_VIEWS, [], { root: true });
      commit(SET_COMPANY_INFO, [])
      commit(PURCHASE_SET_ACTIVE_SUPPLIER, [], { root: true });
      commit(PURCHASE_SET_SUPPLIER, [], { root: true })
      commit(LOGISTICS_SET_LOGISTICS_OPTIONS, [], { root: true });
      commit(LOGISTICS_SET_ACTIVE_LOGISTICS_OPTIONS, [], { root: true })



      commit(SET_TOKEN_COOKIES, {token: '', sevenDaysNoPassword:false});
      commit(SET_TENANT_COOKIES, {tenant: '', sevenDaysNoPassword:false});
      commit(SET_USER_ID_COOKIES, {userId: '', sevenDaysNoPassword:false});
      commit(SET_ACCOUNT_COOKIES, {account: '', sevenDaysNoPassword:false});

      commit(SET_MARKET_AUTH_TYPE, []);
      commit(SET_LATEST_VERSION_ID, null);

      commit(DASHBOARD_SET_TIMEZONE_ID, '', { root: true });
      commit(DASHBOARD_SET_TIMEZONE_TEXT, '', { root: true });
      commit(DASHBOARD_SET_CURRENCY, 'USD', { root: true });

      removePE();
      removeToken();
      removeTenant();
      removeUserId();
      removeAccount();
      resolve()
    })
  },

  // 获取公司信息
  [INNER_GET_COMPANY_INFO]({ commit }) {
    return userCompanyInfo().then(res => {
      if(res.isSuccess) {
        commit(SET_COMPANY_INFO, res.data.map(v => ({
          ...v,
          text: v.consignee,
          id: v.consignee
        })) || [])
      }
      return res
    })
  },

//  获取是否开启轮询
    async [GET_POLLING]({commit}) {
        try {
            const {data} = await getPollingStatus();
            commit(SET_POLLING, data);
        } catch (e) {
            console.log(e)
        }
    }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
